import React from 'react';
import { OverlayTrigger, Popover, Spinner } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import moment from 'moment';

import { GetLastEditorDto } from '../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../common/hooks/useTranslation';

interface LastEditorInfoDisplayProps {
  lastEditor?: GetLastEditorDto;
  isLoading: boolean;
  onEnter: () => void;
  className?: string;
  iconSize?: number;
  placement?: 'left' | 'right' | 'top' | 'bottom';
  additionalText?: string;
}

export const LastEditorInfoDisplay: React.FC<
  LastEditorInfoDisplayProps
> = props => {
  const { t, tk } = useTranslation('commonLng');

  return (
    <OverlayTrigger
      placement={props.placement ?? 'top'}
      onEnter={props.onEnter}
      overlay={
        <Popover id="popover-basic">
          <Popover.Header as="h3" className="text-center">
            {t(tk.common.history)}
          </Popover.Header>
          <Popover.Body className="text-center">
            {props.isLoading ? (
              <Spinner animation="border" variant="secondary" />
            ) : props.lastEditor ? (
              <>
                {props.additionalText && props.lastEditor.additionalTs && (
                  <>
                    <h6>{props.additionalText}:</h6>
                    {t(tk.common.who)}:{' '}
                    {props.lastEditor.additionalOwner ||
                      t(tk.common.noInformation)}{' '}
                    <br />
                    {t(tk.common.when)}:{' '}
                    {props.lastEditor.additionalTs
                      ? moment(props.lastEditor.additionalTs)
                          .locale(t(tk.common.localeShort))
                          .format('LLL')
                      : t(tk.common.noInformation)}
                    <hr />
                  </>
                )}
                <h6>{t(tk.common.lastModification)}:</h6>
                {t(tk.common.who)}:{' '}
                {props.lastEditor.owner || t(tk.common.noInformation)} <br />
                {t(tk.common.when)}:{' '}
                {props.lastEditor.ts
                  ? moment(props.lastEditor.ts)
                      .locale(t(tk.common.localeShort))
                      .format('LLL')
                  : t(tk.common.noInformation)}
                {props.lastEditor.creationTs && (
                  <>
                    <hr />
                    <h6>{t(tk.common.creation)}:</h6>
                    {t(tk.common.who)}:{' '}
                    {props.lastEditor.creator || t(tk.common.noInformation)}{' '}
                    <br />
                    {t(tk.common.when)}:{' '}
                    {props.lastEditor.creationTs
                      ? moment(props.lastEditor.creationTs)
                          .locale(t(tk.common.localeShort))
                          .format('LLL')
                      : t(tk.common.noInformation)}
                  </>
                )}
              </>
            ) : null}
          </Popover.Body>
        </Popover>
      }
    >
      <Icon.InfoCircle
        className={props.className ?? 'last-editor'}
        size={props.iconSize ?? 22}
      />
    </OverlayTrigger>
  );
};
